import { useTranslation } from 'react-i18next';
import LayoutStatusPage from '../../components/LayoutStatusPage';
import { useTheme } from '@mui/material';
import { Helmet } from 'react-helmet-async';

const InternalError = () => {
  const { t } = useTranslation();
  const theme = useTheme();
  return (
    <>
      <Helmet>
        <meta name="robots" content="noindex,nofollow" />
      </Helmet>
      <LayoutStatusPage
        imgUrl={
          theme.palette.mode === 'dark' ? 'warning-2-dark.svg' : 'warning-2.svg'
        }
        title={t('internal_error.title')}
        text={t('internal_error.first_text')}
        secondText={t('internal_error.second_text')}
        routerBack="/"
      />
      ;
    </>
  );
};
export default InternalError;
